import type { CommunityTopic } from '@/mocks/community';

interface TopicDetailModalProps {
  topic: CommunityTopic | null;
  onClose: () => void;
  onToast: (message: string) => void;
}

export default function TopicDetailModal({ topic, onClose, onToast }: TopicDetailModalProps) {
  if (!topic) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4" role="dialog" aria-modal="true">
      <button
        type="button"
        aria-label="关闭"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/40 cursor-pointer"
      ></button>
      <div className="relative w-full max-w-2xl rounded-lg bg-background-50 p-6 md:p-7 animate-fade-up max-h-[88vh] overflow-y-auto">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-bold">
              {topic.avatar}
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{topic.author}</p>
              <p className="text-xs text-foreground-400">发布于 {topic.updatedAt}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:bg-background-100 transition-colors"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <h3 className="mt-5 font-heading text-xl font-bold leading-snug text-foreground-950">
          {topic.title}
        </h3>

        <div className="mt-4 space-y-3">
          {topic.content.map((paragraph, index) => (
            <p key={`para-${index}`} className="text-sm md:text-base leading-7 text-foreground-700">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {topic.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-50 border border-secondary-200 px-3 py-1 text-xs text-secondary-700"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-3 border-t border-background-200 pt-5">
          <button
            type="button"
            onClick={() => onToast('感谢参与，点赞功能即将上线（演示）')}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm text-foreground-600 hover:border-accent-300 hover:text-accent-600 transition-colors"
          >
            <i className="ri-thumb-up-line"></i>
            有启发
          </button>
          <button
            type="button"
            onClick={() => onToast('评论功能为演示状态，暂不保存内容')}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors"
          >
            <i className="ri-chat-3-line"></i>
            回复 ({topic.replies})
          </button>
          <button
            type="button"
            onClick={() => onToast('已复制话题链接（演示）')}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors"
          >
            <i className="ri-share-forward-line"></i>
            分享
          </button>
        </div>

        <p className="mt-4 text-xs text-foreground-400">
          当前社区互动为前端演示，实际数据接口待接入。
        </p>
      </div>
    </div>
  );
}